import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import Layout from './components/Layout';
import { Home } from './components/Home';
import { PrivateRoute } from './components/PrivateRoute';
import LoginPage from './components/LoginPage';

import SendExport from './components/insem/LoadExport';
import LastExportResult from './components/insem/LoadExportLast';
import LoadExportHist from './components/insem/LoadExportHist';

import NotificationsList from './components/pssr/Notifications';
import NotificationsHist from './components/pssr/NotHistory';
import NotificationsEmails from './components/pssr/NotEmails';
import NotificationsStatus from './components/pssr/NotStatus';

import { hasRole, roles } from './services/user.service';
import { SnackbarProvider } from 'material-ui-snackbar-provider'
import { NotFound } from './components/NotFound';

import InseminationDetail from './components/technik/InseminationDetail';
import InseminationList from './components/technik/InseminationList';
import AnimalList from './components/technik/AnimalList';
import Settings from './components/technik/Settings';
import { AnimalDetail } from './components/technik/AnimalDetail';
import CalvingReport from './components/technik/CalvingReport';
import UpdateDB from './components/pssr/UpdateDB';
import DbModifRequest from './components/insem/DBRequest'

export default class App extends Component {
    static displayName = App.name;
    render() {

        return (
            <Layout>
                <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000, anchorOrigin: { horizontal: 'center', vertical: 'top' } }}>
                    <Switch>
                        <PrivateRoute exact path='/' component={Home} />
                        <Route path='/login' component={LoginPage} />
                        {hasRole(roles.technik) && <PrivateRoute path='/insemination-detail/:id/:animalCode/:date' component={InseminationDetail} />}
                        {hasRole(roles.technik) && <PrivateRoute path='/insemination-list' component={InseminationList} />}
                        {hasRole(roles.technik) && <PrivateRoute path='/animal-list' component={AnimalList} />}
                        {hasRole(roles.technik) && <PrivateRoute path='/settings' component={Settings} />}
                        {hasRole(roles.technik) && <PrivateRoute path='/animal-detail/:id' component={AnimalDetail} />}
                        {hasRole(roles.technik) && <PrivateRoute path='/calving-report' component={CalvingReport} />}

                        {hasRole(roles.insem) && <PrivateRoute path='/export-send' component={SendExport} />}
                        {hasRole(roles.insem) && <PrivateRoute path='/export-last' component={LastExportResult} />}
                        {hasRole(roles.insem) && <PrivateRoute path='/export-hist' component={LoadExportHist} />}
                        {hasRole(roles.insem) && <PrivateRoute path='/modifdb-req' component={DbModifRequest} />}

                        {hasRole(roles.pssr) && <PrivateRoute path='/not-edit' component={NotificationsList} />}
                        {hasRole(roles.pssr) && <PrivateRoute path='/not-hist' component={NotificationsHist} />}
                        {hasRole(roles.pssr) && <PrivateRoute path='/not-sent' component={NotificationsEmails} />}
                        {hasRole(roles.pssr) && <PrivateRoute path='/not-state' component={NotificationsStatus} />}
                        {hasRole(roles.pssr) && <PrivateRoute path='/update-db' component={UpdateDB} />}
                        <Route path="*" component={NotFound} />
                    </Switch>
                </SnackbarProvider>
            </Layout>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js